<template>
  <v-card outlined>
    <v-container class="px-1 py-1" fluid>
      <v-card-title class="pt-2 pb-0">
        {{ $t('ELE0028') }}
      </v-card-title>
      <v-card-text>
        <v-row dense class="py-2">
          <v-col cols="12" sm="6">
            <AcceptCompanyInput :label="$t('ELE0127')" v-model="searchCondition.companyCd" required />
          </v-col>
        </v-row>
        <v-row class="px-1">
          <v-col cols="12" md="9" class="py-2">
            <v-row dense>
              <TextFieldInputWithDatePicker :label="$t('ELE0128')" v-model="searchCondition.fromDate" />
              <span class="px-4 py-2"> {{ $t('ELE0141') }} </span>
              <TextFieldInputWithDatePicker :label="$t('ELE0129')" v-model="searchCondition.toDate" />
            </v-row>
          </v-col>
          <v-col cols="12" md="3">
            <v-row justify="end">
              <v-card-text>
                <BtnSearch @click="onClickSearch" />
              </v-card-text>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="displayResultComputed">
          <v-col>
            <v-card outlined>
              <v-card-title class="py-2 pb-2">
                {{ $t('ELE0023') }}
                <v-spacer />
                <Btn :label="$t('ELE0325')" @click="onPrintClick" :disabled="!displayResultComputed" />
                <BtnCsvDownload
                  class="mx-2"
                  :label="$t('ELE0040')"
                  fileTitle="insp_load"
                  :items="[]"
                  :itemParsed="csvOutputDataComputed"
                />
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="inspLoadDetailsComputed"
                disable-pagination
                hide-default-footer
                dense
              >
                <template v-slot:header>
                  <thead>
                    <tr>
                      <th class="top-headers border-top" colspan="3"></th>
                      <th
                        v-for="(item, index) in weekHeaderComputed"
                        v-bind:key="index"
                        :class="`${
                          index !== weekHeaderComputed.length - 1 ? 'top-headers' : ''
                        } border-top text-center`"
                        :colspan="item.days"
                      >
                        {{ item.name }}
                      </th>
                    </tr>
                  </thead>
                </template>
                <template v-slot:item.shift="{ item, index }">
                  <td :class="getCellClass(index, 'shiftBorder')">{{ item.shift }}</td>
                </template>
                <template v-slot:item.type="{ item, index }">
                  <td :class="getCellClass(index, 'typeBorder')">{{ item.type }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-if="displayResultComputed">
        <v-container class="px-0" fluid>
          <v-row>
            <v-col cols="6" v-for="(item, index) in chartListComputed" :key="`${item.shift}DIM${index}`">
              <InspLoadDimChart :companyName="selectedCompany" :name="item.shift" :items="item.load" />
            </v-col>
            <v-col cols="6" v-for="(item, index) in chartListComputed" :key="`${item.shift}APP${index}`">
              <InspLoadAppChart :companyName="selectedCompany" :name="item.shift" :items="item.load" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import StringUtils from '@/mixin/string-utils.js'
import CompanyInput from '@/components/atoms/select/CompanyInput.vue'
import BtnSearch from '@/components/atoms/button/BtnSearch.vue'
import Btn from '@/components/atoms/base/button/Btn'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker.vue'
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'
import InspLoadDimChart from '@/components/organisms/report/chart/InspLoadDimChart.vue'
import InspLoadAppChart from '@/components/organisms/report/chart/InspLoadAppChart.vue'
import AcceptCompanyInput from '@/components/atoms/select/AcceptCompanyInput.vue'
import BtnCsvDownload from '@/components/atoms/button/BtnCsvDownload'

export default {
  name: 'InspLoadForm',

  components: {
    CompanyInput,
    TextFieldInputWithDatePicker,
    BtnSearch,
    Btn,
    InspLoadDimChart,
    InspLoadAppChart,
    AcceptCompanyInput,
    BtnCsvDownload,
  },

  mixins: [APIUtils, Message, Loading, DateUtils, StringUtils],

  data() {
    return {
      searchCondition: {
        companyCd: '',
        fromDate: moment().day(-7).format('YYYY-MM-DD'),
        toDate: moment().day(6).format('YYYY-MM-DD'),
      },
      selectedCompany: '',
      headers: [
        { text: this.$t('ELE0130'), value: 'shift', width: '100', divider: true, sortable: false },
        { text: this.$t('ELE0294'), value: 'type', width: '100', divider: false, sortable: false },
        { text: '', value: 'itemName', width: '200', divider: true, sortable: false },
      ],
      weekHeader: [],
      inspLoadDetailTemplate: [
        { shift: '1', type: 'MP DIM', shiftBorder: false, typeBorder: false, itemName: this.$t('ELE0296') },
        { shift: '', type: '', shiftBorder: false, typeBorder: false, itemName: this.$t('ELE0297') },
        { shift: '', type: '', shiftBorder: false, typeBorder: false, itemName: this.$t('ELE0298') },
        { shift: '', type: '', shiftBorder: false, typeBorder: false, itemName: this.$t('ELE0108') },
        { shift: '', type: '', shiftBorder: false, typeBorder: false, itemName: this.$t('ELE0109') },
        { shift: '', type: '', shiftBorder: false, typeBorder: false, itemName: this.$t('ELE0299') },
        { shift: '', type: '', shiftBorder: false, typeBorder: false, itemName: this.$t('ELE0300') },
        { shift: '', type: '', shiftBorder: false, typeBorder: false, itemName: this.$t('ELE0301') },
        { shift: '', type: '', shiftBorder: false, typeBorder: false, itemName: this.$t('ELE0110') },
        { shift: '', type: '', shiftBorder: false, typeBorder: true, itemName: this.$t('ELE0111') },
        { shift: '', type: 'APP', shiftBorder: false, typeBorder: false, itemName: this.$t('ELE0303') },
        { shift: '', type: '', shiftBorder: false, typeBorder: false, itemName: this.$t('ELE0112') },
        { shift: '', type: '', shiftBorder: false, typeBorder: false, itemName: this.$t('ELE0113') },
        { shift: '', type: '', shiftBorder: true, typeBorder: true, itemName: this.$t('ELE0302') },
      ],
      inspLoadDetailTotal: [
        { shift: '', type: '', itemName: this.$t('ELE0114') },
        { shift: '', type: '', itemName: this.$t('ELE0304') },
        { shift: '', type: '', shiftBorder: true, typeBorder: true, itemName: this.$t('ELE0305') },
      ],
      inspLoadDetail: [],
      chartList: [],
      //CSV data
      csvTopHeader: '', //rows containing "week names"
      csvMainHeader: '', //row's main header with "dates"
      dateHeaderArray: [], //list of dates 日付の一覧
      //Keys of row's first two columns in array
      rowInitialsArray: ['shift', 'type', 'itemName'], //length must be equal to csvMainHeader length when initialized
    }
  },
  computed: {
    displayResultComputed: {
      get() {
        return this.weekHeader.length > 0
      },
    },
    chartListComputed: {
      get() {
        return this.chartList
      },
      set(value) {
        this.chartList.push(value)
      },
    },
    inspLoadDetailsComputed: {
      get() {
        return this.inspLoadDetail
      },
      set(shiftNameList) {
        this.inspLoadDetail = []
        shiftNameList.forEach((element) => {
          const newArrayTemplate = this.inspLoadDetailTemplate.map((item) => {
            return {
              ...item,
              shift: item.shift == '1' ? element : '',
            }
          })
          this.inspLoadDetail.push(...newArrayTemplate)
        })
        this.inspLoadDetail.push(...this.inspLoadDetailTotal)
      },
    },
    weekHeaderComputed: {
      get() {
        return this.weekHeader
      },
      set(week) {
        this.weekHeader = week.map((item) => {
          return {
            days: item.days,
            name: `${this.getNumberSuffix(item.name)} Week`,
          }
        })
      },
    },
    headersComputed: {
      get() {
        return this.headers
      },
      set(header) {
        this.headers = cloneDeep(header)
      },
    },
    csvOutputDataComputed: {
      get() {
        //add top header, main header and data
        return (
          this.csvTopHeader +
          this.csvMainHeader +
          this.convertToCSV(this.inspLoadDetailsComputed, this.dateHeaderArray, this.rowInitialsArray)
        )
      },
    },
  },
  methods: {
    initCSVData() {
      this.csvTopHeader = ',,,'
      this.csvMainHeader = this.$t('ELE0130') + ',' + this.$t('ELE0294') + ',,'
      this.dateHeaderArray = []
    },
    onPrintClick() {
      const props = {
        company: this.searchCondition.companyCd,
        dateFrom: this.searchCondition.fromDate,
        dateTo: this.searchCondition.toDate,
        inspLoadListHeaders: this.headers,
        inspLoadList: this.inspLoadDetail,
        weekHeader: this.weekHeader,
        chartList: this.chartList,
      }
      this.$router.push({ name: 'InspLoadPageReport', params: props })
    },
    async onClickSearch() {
      this.startLoading()
      try {
        if (this.searchCondition.companyCd.length < 1) {
          this.setErrorMessage(this.$t('MSG0019', { p0: this.$t('ELE0127') }))
          return
        }
        if (moment(this.searchCondition.fromDate).add(35, 'd') <= moment(this.searchCondition.toDate)) {
          this.setErrorMessage(this.$t('MSG0096', { p0: '35' }))
          return
        }
        this.chartList = []
        // TODO: Remove this POST api after auto register into batch tables are applied
        // 自動でバッチに登録する機能が作って終わった後下のAPIを消す
        // const saveResponse = await API.post('/totalling/save-insp-load', this.searchCondition)
        // console.log(saveResponse)
        const calendarList = await API.get('/master/calendar', this.searchCondition)
        const response = await API.get('/totalling/insp-load', this.searchCondition)
        if (response) {
          this.initCSVData()
          this.weekHeader = []
          let week = []
          let weekCount = 0
          const shiftList = response.map((element) => element.shift)
          this.resetTable()
          this.inspLoadDetailsComputed = shiftList
          response.forEach((item, shiftIndex) => {
            this.chartListComputed = {
              shift: item.shift,
              load: item.dailyLoad,
            }
            item.dailyLoad.forEach((load, index) => {
              let rowIndex = shiftIndex * 14
              const {
                analyzedQty,
                date,
                capaAppNormal,
                capaAppOt,
                capaDimNormal,
                capaDimOt,
                capaInsp,
                totalAppLot,
                totalDimLot,
                totalReceiveEsLot,
                totalReceiveLot,
                totalSameLot,
                totalTdm,
                totalTms,
                outstandingDimLot,
                outstandingAppLot,
              } = load
              let dateValue = moment(date).format('YYYY-MM-DD')
              if (shiftIndex == 0) {
                this.headers.push({
                  text: moment(date).format('Do MMM'),
                  value: dateValue,
                  divider: item.dailyLoad.length - 1 !== index,
                  sortable: false,
                  align: 'right',
                })
                this.csvMainHeader = this.csvMainHeader + moment(date).format('Do MMM') + ','
                this.dateHeaderArray.push(date)
                // const weekMonth = this.getISOWeekInMonth(moment(date).toDate()).week
                const weekMonth = calendarList.find((item) => item.date == dateValue).weekCd
                if (weekMonth != week[week.length - 1]?.name) {
                  weekCount = 0
                  this.csvTopHeader = this.csvTopHeader + `${this.getNumberSuffix(weekMonth)} Week,`
                } else {
                  this.csvTopHeader = this.csvTopHeader + ','
                }
                if (weekCount == 0) {
                  week.push({
                    days: weekCount + 1,
                    name: weekMonth,
                  })
                } else {
                  week[week.length - 1] = {
                    days: weekCount + 1,
                    name: weekMonth,
                  }
                }
                weekCount++
              }
              // Fill in the table columns
              this.inspLoadDetail[rowIndex++][dateValue] = totalReceiveLot ?? 0
              this.inspLoadDetail[rowIndex++][dateValue] = totalReceiveEsLot ?? 0
              this.inspLoadDetail[rowIndex++][dateValue] = analyzedQty ?? 0
              this.inspLoadDetail[rowIndex++][dateValue] = capaDimNormal ?? 0
              this.inspLoadDetail[rowIndex++][dateValue] = capaDimOt ?? 0
              this.inspLoadDetail[rowIndex++][dateValue] = totalDimLot ?? 0
              this.inspLoadDetail[rowIndex++][dateValue] = totalSameLot ?? 0
              this.inspLoadDetail[rowIndex++][dateValue] = outstandingDimLot ?? 0
              this.inspLoadDetail[rowIndex++][dateValue] = totalTdm ?? 0
              this.inspLoadDetail[rowIndex++][dateValue] = totalTms ?? 0
              this.inspLoadDetail[rowIndex++][dateValue] = totalAppLot ?? 0
              this.inspLoadDetail[rowIndex++][dateValue] = capaAppNormal ?? 0
              this.inspLoadDetail[rowIndex++][dateValue] = capaAppOt ?? 0
              this.inspLoadDetail[rowIndex++][dateValue] = outstandingAppLot ?? 0
              if (shiftIndex == response.length - 1) {
                //Capa Insp (Full MP)
                this.inspLoadDetail[rowIndex++][dateValue] = capaInsp ?? 0
                //Total Receive/day
                this.inspLoadDetail[rowIndex++][dateValue] = this.getSumFromTable(0, rowIndex, dateValue)
                //Total MP Dim Insp
                this.inspLoadDetail[rowIndex++][dateValue] = this.getSumFromTable(5, rowIndex, dateValue)
              }
            })
          })
          this.weekHeaderComputed = week
          this.selectedCompany = this.searchCondition.companyCd
          this.csvTopHeader = this.csvTopHeader + '\n'
          this.csvMainHeader = this.csvMainHeader + '\n'
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0322') })))
      } finally {
        this.stopLoading()
      }
    },
    getCellClass(index, value) {
      const currentValue = this.inspLoadDetailsComputed[index]?.[value]
      let cellClass = 'v-data-table__divider'
      if (!currentValue) {
        cellClass = cellClass.concat(' border-b-none')
      }
      return cellClass
    },
    resetTable() {
      this.headersComputed = this.headers.splice(0, 3)
      this.inspLoadDetail = []
    },
    getSumFromTable(start, rowIndex, date) {
      const shiftRowList = []
      for (let i = start; i < rowIndex - (rowIndex % 14); i = i + 14) {
        shiftRowList.push(this.inspLoadDetail[i][date])
      }
      return shiftRowList.reduce((prev, curr) => prev + curr, 0)
    },
  },
  mounted() {
    this.initCSVData()
  },
}
</script>

<style>
.border-b-none {
  border-bottom: none !important;
}

.display-none {
  content-visibility: hidden;
}

.border-top {
  border-top: 1px solid;
}
</style>
